// helper functions
function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}
function removeClass(el, classname) {
    el.className = el.className.replace(" " + classname, "");
}
function addClass(el, classname) {
    el.className += " " + classname;
}
function slideDown(el) {
    el.style.opacity = "1";
    el.style.maxHeight = el.scrollHeight + "px";
}
function slideUp(el) {
    el.style.maxHeight = "0px";
    window.setTimeout(function () {
        el.style.opacity = 0;
    }, 500);
}
function qs_val(param) {
    /* qs_val() grabs query string values 
        * based on passed in param arg
        * 
        * @param {String} param 
        * @return {String} value associated with qs param
        * */
    // try URLSearchParams first
    if ('URLSearchParams' in window) {
        var urlParams = new URLSearchParams(window.location.search);
        var theVal = urlParams.get(param);
        return theVal;
    }
    // if no URLSearchParams support, use regex
    var url = window.location.href;
    var regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url)
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    var theVal = decodeURIComponent(results[2]);
    return theVal;
}

// vars
var playlistId = document.getElementById('ytplaylist').getAttribute('data-playlist-id');
var videoIds = document.getElementById('ytplaylist').getAttribute('data-playlist');
var firstVid = document.getElementById('ytplaylist').getAttribute('data-first');
var playlist = [];
var videoUnstarted = false;
var videoNotPlayed = true;
var player;
var mobileAnno = document.querySelector('.playlistdiv .mobile-annotations');
var stacked = hasClass(document.getElementById('ytplaylist'), 'stackedYT');
var hlInterval = null;

// main functions

function removeHighlights() {
    var highlighted = document.querySelectorAll('.plTimeStamp.highlight');
    if (highlighted.length > 0){
        for (var i = 0; i < highlighted.length; i++) {
            removeClass(highlighted[i], 'highlight');
        }
    }
}
function revealBtns(btns) {
    slideDown(btns);
    // go through all the buttons and add tab index
    var theButtons = btns.querySelector('button');
    for (var i = 0; i < theButtons.length; i++) {
        theButtons[i].setAttribute('tabindex', '0');
    }
    // add the btns to the mobile annotation sections
    var cloneBtns = btns.cloneNode(true);
    cloneBtns.removeAttribute("style");
    mobileAnno.innerHTML = '<p class="annoHeader">Annotations</p>';
    mobileAnno.appendChild(cloneBtns);
}
function hideBtns(btns) {
    removeHighlights();
    // go through all the buttons and remove tab index
    var theButtons = btns.querySelector('button');
    for (var i = 0; i < theButtons.length; i++) {
        theButtons[i].setAttribute('tabindex', '-1')
    }
    slideUp(btns);
    
    mobileAnno.innerHTML = '';
}
function setHl() {
    hlInterval = setInterval(hlCurrentAnno, 1000);
}
function clearHl() {
    clearInterval(hlInterval);
}


// if (playlistID.match(',')) {
//     playlistID = playlistID.split(',');
// }
// api key
function onYouTubePlayerAPIReady() {
    var options = {
        // videoId: firstVid,
        playerVars: {
            showinfo: 0,
            rel: 0,
            ecver: 2,
            wmode: 'opaque',
            origin: 'https://www.monmouth.edu'
        }
    }
    if (playlistId) {
        // options.playerVars.listType = 'playlist';
        // options.playerVars.list = playlistId;
    } else {
        options.playerVars.playlist = videoIds;
    }
    player = new YT.Player('ytVid', options)
    player.addEventListener('onReady', 'playerReady');
    player.addEventListener('onStateChange', 'stateChange');
}

// load video 
function loadVid() {
    // Load the IFrame Player API code asynchronously.
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

// event: the player is ready
function playerReady(e) {
    var player = e.target;
    var video = qs_val('video');
    var pos = null;
    var time = qs_val('time');
    var seconds = null;
    if (video) {
        pos = player.getPlaylist().indexOf(video);
        player.playVideoAt(pos);
    }
    if (time && !isNaN(time)) {
        seconds = time;
        player.seekTo(seconds, true);
    }
    var curIframe = document.getElementById('ytVid');
    curIframe.removeAttribute('frameborder');
    curIframe.removeAttribute('width');
    curIframe.removeAttribute('height');
    setHl();
    if (playlistId) {
        e.target.loadPlaylist({
            list: playlistId,
            listType: 'playlist'
        });
    }
}
// events: video ends or is skipped
function stateChange(state) {
    // video goes to next 
    if (state.data == -1) {
        videoUnstarted = true;
    }
    if (state.data == YT.PlayerState.ENDED) {
        var curIndex = player.getPlaylistIndex();
        jQuery('.plElement[data-pos="' + curIndex + '"]').removeClass('active');
        jQuery('.plElementWrapper[data-pos="' + curIndex + '"]').removeClass('active');
        var btns = document.querySelector('.plElement[data-pos="' + curIndex + '"] + .plStamps');
        if (btns) {
            hideBtns(btns);
        }
    }
    if (videoUnstarted && state.data == YT.PlayerState.BUFFERING) {
        if (videoNotPlayed) {
            videoNotPlayed--;
        }
        videoUnstarted--;
        var curIndex = player.getPlaylistIndex();
        var lastIndexEl = document.querySelector('.plElement.active');
        var lastIndex = '';
        if (lastIndexEl) {
            lastIndex = lastIndexEl.getAttribute('data-pos');
            if (lastIndex != curIndex) {
                jQuery('.plElement[data-pos="' + lastIndex + '"]').removeClass('active');
                jQuery('.plElementWrapper[data-pos="' + lastIndex + '"]').removeClass('active');
                var btns = document.querySelector('.plElement[data-pos="' + lastIndex + '"] + .plStamps');
                if (btns) {
                    hideBtns(btns);
                }
            }
        }
        jQuery('.plElement[data-pos="' + curIndex + '"]').addClass('active');
        jQuery('.plElementWrapper[data-pos="' + curIndex + '"]').addClass('active');
        var btns = document.querySelector('.plElement[data-pos="' + curIndex + '"] + .plStamps');
        if (btns) {
            revealBtns(btns);
        }
        ytSlide(curIndex, lastIndex);
    }
}
// event 2: user selects another video
function plElClick(el) {
    var nextVidPos = jQuery(el).attr('data-pos');
    var curIndex = player.getPlaylistIndex();
    if (nextVidPos != curIndex || videoNotPlayed) {
        player.playVideoAt(nextVidPos);
    }
}
// event 3: user clicks a timestamp button
function timestampClick(el) {
    clearHl();
    var seconds = jQuery(el).attr('data-seconds');
    player.seekTo(seconds, true);
    player.playVideo();
    if (!hasClass(el, 'highlight')) {
        removeHighlights();
        addClass(el, 'highlight');
    }
    setHl();
}

// slide to current vid, or slide to youtube        
function ytSlide(curIndex, lastIndex) {
    var curEl = document.querySelector('.plElementWrapper[data-pos="' + curIndex + '"]');
    if (!curEl) {
        curEl = document.querySelector('.plElement[data-pos="' + curIndex + '"]');
    }
    if (lastIndex) {
        var lastEl = document.querySelector('.plElementWrapper[data-pos="' + lastIndex + '"]');
        if (!lastEl) {
            lastEl = document.querySelector('.plElement[data-pos="' + lastIndex + '"]');
        }
        var btns = lastEl.querySelector('.plElement[data-pos="' + lastIndex + '"] + .plStamps');
    }
    if (!stacked && jQuery(document).width() > 768 ) {
        var topPos = curEl.offsetTop;
        if (lastIndex < curIndex && btns) {
            var btnHeight = btns.offsetHeight;
            topPos -= btnHeight;
        }
        var parentEl = document.querySelector('.playlistdiv');
        var parentPos = parentEl.offsetTop;
        var offsetDif = topPos - parentPos;
        jQuery(parentEl).animate({
            scrollTop: offsetDif
        }, 600, 'swing');
    } else {
        var ytDiv = jQuery('.theVideo');
        var ytPos = ytDiv.offset().top;
        var navbar = document.querySelector('header.header');
        var blueheader = document.querySelector('.blueheader');
        var headerHeight = (navbar) ? navbar.offsetHeight : 0;
        var blueHeight = (blueheader) ? blueheader.offsetHeight : 0;
        var scrollAmt = ytPos - headerHeight;
        jQuery('html, body').animate({
            scrollTop: scrollAmt
        }, 600, 'swing');
    }
}

jQuery(document).on('click', '.plElement', function () {
    plElClick(this);
})

jQuery(document).on('click', '.plTimeStamp', function () {
    timestampClick(this);
})

function hlCurrentAnno() {
    // get time and cur playlist index
    var curTime = window.player.getCurrentTime();
    var curIndex = window.player.getPlaylistIndex();
    // get mobile and dt annos
    var dtAnnos = document.querySelectorAll('.plElement[data-pos="' + curIndex + '"] .plTimeStamp');
    var mbAnnos = document.querySelectorAll('.mobile-annotations .plTimeStamp');
    // grab the annos that need highlighting (if they exist)
    var dtLatest = findCurrentAnno(curTime, dtAnnos);
    var mbLatest = findCurrentAnno(curTime, mbAnnos);
    // if there's anything to highlight, highlight it;
    if (dtLatest !== null) {
        for (var i = 0; i < dtAnnos.length; i++) {
            removeClass(dtAnnos[i], 'highlight');
        }
    }
    if (dtLatest) {
        addClass(dtLatest, 'highlight');
    }
    if (mbLatest !== null) {
        for (var i = 0; i < mbAnnos.length; i++) {
            removeClass(mbAnnos[i], 'highlight');
        }
    }
    if (mbLatest) {
        addClass(mbLatest, 'highlight');
    }
    function findCurrentAnno(curTime, els) {
        /* ** RETURNS **
         * true: new el needs highlighting
         * false: els exist but no highlight (or cur hl needs removal)
         * null: no els, or current highlight stays
         * */
        var latest = false;
        var found = false;
        var elTime = null;
        // no els, return false
        if (els.length < 1) {
            return null;
        }
        // go through each el, find the timestamp the video is referencing
        for (var i = 0; i < els.length; i++) {
            elTime = els[i].getAttribute('data-seconds')
            if (!elTime) {
                continue;
            }
            if (elTime <= curTime) {
                found = true;
                latest = els[i];
            } else if (found == true) {
                break;
            }
        }
        if (hasClass(latest, 'highlight')) {
            latest = null;
        }
        return latest;
    }
    
}
